import { FC } from 'react'
import { ShoppingCartOutlined } from '@ant-design/icons'

import Box from '~/core/Box'
import Text from '~/core/Text'
import { punchoutSessionStorage } from '~/lib/services/WebStorage/PunchoutSessionStorage'

import styles from './styles.css'

export const ActivePunchoutSessionIndicator: FC = () => {
    const activePunchoutSession = punchoutSessionStorage.getItem()

    if (!activePunchoutSession) {
        return null
    }

    return (
        <>
            <Box className={styles.activeSessionText}>
                <ShoppingCartOutlined />
                <Text style={{ marginLeft: '8px' }}>
                    Ordering via procurement system...
                </Text>
            </Box>
            <Box className={styles.activeSessionBorder} />
        </>
    )
}
